import React from 'react';
import { Chip } from '@mui/material';
import { getChipColor } from '@utils/get-chip-color';
import { StatusesEnum } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var statusOptions = [{
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.New,
    color: getChipColor(StatusesEnum.New)
  }),
  value: StatusesEnum.New
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.Active,
    color: getChipColor(StatusesEnum.Active)
  }),
  value: StatusesEnum.Active
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.Block,
    color: getChipColor(StatusesEnum.Block)
  }),
  value: StatusesEnum.Block
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.PinLocked.replaceAll('_', ' '),
    color: getChipColor(StatusesEnum.PinLocked)
  }),
  value: StatusesEnum.PinLocked
}];
var statusOrganizationOptions = [{
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.Active,
    color: getChipColor(StatusesEnum.Active)
  }),
  value: StatusesEnum.Active
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.Block,
    color: getChipColor(StatusesEnum.Block)
  }),
  value: StatusesEnum.Block
}];
export { statusOptions, statusOrganizationOptions };